import ApiService from '@/common/api.service';

const url = '/v1/sanmers';

const SanmerService = {
  query(filters) {
    let params = {};

    Object.keys(filters).forEach(key => {
      params[key] = filters[key];
    });

    return ApiService.query(url, { params: params });
  },
  get(id) {
    return ApiService.get(url, id);
  },
  delete(id) {
    return ApiService.delete(`${url}/${id}`);
  },
  save(id = null, sanmer) {
    if (!id) {
      return ApiService.post(url, sanmer);
    }
    return ApiService.update(url, id, sanmer);
  }
};

export default SanmerService;
